import MeasurementsPlot from './MeasurementsPlot';

export default MeasurementsPlot;
